import InputLabel, { InputLabelProps } from '@mui/material/InputLabel';

const InputLabelC = (props: InputLabelProps) => (
    <InputLabel
        style={{
            padding: '0 6px',
            left: '-4px',
            marginBottom: 3,
        }}
        {...props}
    />
);

export default InputLabelC;
